import { LabeledControl, Label, Checkbox } from '@zillow/constellation';
import { Field, FieldProps } from 'formik';
import React from 'react';

export const Confirmation: React.FC = () => {
  return (
    <Field name="confirmation">
      {({ field }: FieldProps<boolean>) => (
        <LabeledControl
          label={<Label>Verified Cancelled in Wells Fargo</Label>}
          control={<Checkbox {...field} value={undefined} checked={field.value} />}
        />
      )}
    </Field>
  );
};
